document.querySelectorAll('.popup-btn').forEach(element => {
  element.addEventListener('click', function (e) {
    e.stopPropagation();
    var tar = event.target.getAttribute("data-target");
    console.log(tar);
    
    document.querySelector(`#${tar}.popup-overlay`).style.display = 'block';
    document.querySelector(`#${tar} .popup`).style.display = 'block';
  }, false);
});

document.querySelectorAll('.popup-close').forEach(element => {
  element.addEventListener('click', function (e) {
    var tar = event.target.getAttribute("data-target");
    console.log(e.target);
    
    document.querySelector(`#${tar}.popup-overlay`).style.display = 'none';
    document.querySelector(`#${tar} .popup`).style.display = 'none';
    
    var src = document.querySelector(`#${tar} .popup iframe`).getAttribute('src');
    document.querySelector(`#${tar} .popup iframe`).setAttribute('src', src);
  }, false);
});                                             

document.querySelector('body').addEventListener('click', function () {
  document.querySelector('.popup').style.display = 'none';
  document.querySelector('.popup-overlay').style.display = 'none';
  }, false);

// document.querySelector('.popup').addEventListener('click', function (e) {
//   e.stopPropagation();
// }, false);